import Vue from 'vue'
import Vuex from 'vuex'
import notification from './modules/notification';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
    async request(store, params) {
      return Vue.axios({
        ...params
      });
    },
  },
  modules: {
    notification: notification
  }
})
